var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInstagram = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 8.222c-1.14 0-2.11.97-2.11 2.111s.97 2.112 2.11 2.112c1.142 0 2.111-.97 2.111-2.112 0-1.14-.97-2.11-2.11-2.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.04 4H7.684C5.612 4 4 5.612 4 7.627v5.355c0 2.073 1.612 3.685 3.685 3.685h5.354c2.016 0 3.628-1.613 3.628-3.685V7.627A3.61 3.61 0 0 0 13.039 4m-2.707 9.673a3.28 3.28 0 0 1-3.281-3.282c0-1.785 1.439-3.34 3.281-3.34a3.28 3.28 0 0 1 3.282 3.282c0 1.785-1.44 3.34-3.282 3.34m3.397-5.93a.76.76 0 0 1-.748-.75c0-.402.345-.748.748-.748s.749.346.749.749a.76.76 0 0 1-.749.748"
  })));
};
export default SvgIcInstagram;